import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

import { bigNumberWithCommas } from '@openx/utils/lib/bigNumberWithCommas';
import type { JSX } from 'react';
import type { UploadFileProgressProps } from './types';

export function UploadFileProgress({ recordsProcessed, progress }: UploadFileProgressProps): JSX.Element {
  return (
    <Box>
      <Typography variant="body1Bold">Publishing</Typography>
      <LinearProgress
        value={progress}
        variant="determinate"
        sx={{ borderRadius: 3, height: 10, margin: theme => theme.spacing(2, 0) }}
      />
      <Typography>
        <Typography variant="body1Bold" component="span">
          {bigNumberWithCommas(recordsProcessed)}
        </Typography>{' '}
        lines processed
      </Typography>
    </Box>
  );
}
